import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import Layout from "./components/layout/Layout";
import HomePage from "./components/pages/HomePage";
import ProjectsPage from "./components/pages/ProjectsPage";
import ProjectDetailPage from "./components/pages/ProjectDetailPage";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";
import AdminRouter from "./components/admin/AdminRouter";
import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/*" element={<AdminRouter />} />
          
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/projeler"
            element={
              <Layout>
                <ProjectsPage />
              </Layout>
            }
          />
          <Route
            path="/projeler/:id"
            element={
              <Layout>
                <ProjectDetailPage />
              </Layout>
            }
          />
          <Route
            path="/hakkimizda"
            element={
              <Layout>
                <AboutPage />
              </Layout>
            }
          />
          <Route
            path="/iletisim"
            element={
              <Layout>
                <ContactPage />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
